import React, { ReactNode } from 'react';

import {
    NavigationAdminConfigurationProvider,
    NavigationAdminConfigurationProviderProps,
} from '../../context/NavigationAdminConfigurationProvider';
import {
    NavigationAdminVisibleByReferenceProvider,
    NavigationAdminVisibleByReferenceProviderProps,
} from '../../context/NavigationAdminVisibleByReferenceProvider';
import { NavigationListFilterProvider } from '../../context/NavigationListFiltersProvider';
import { NavigationAdminConfiguration } from '../../types';

export interface NavigationMapContextProviderProps {
    configuration?: NavigationAdminConfiguration;
    visibleByGroupReferences?: NavigationAdminVisibleByReferenceProviderProps['visibleByReference'];
    defaultFeeds?: NavigationAdminConfigurationProviderProps['defaultFeeds'];
    children: ReactNode;
}

/**
 * A ContextProvider that takes options and set a React Context with internal state, values and callbacks
 */
export const NavigationMapContextProvider: React.FC<NavigationMapContextProviderProps> = ({
    configuration = {},
    visibleByGroupReferences = {},
    defaultFeeds = {},
    children,
}) => {
    return (
        <NavigationAdminConfigurationProvider defaultFeeds={defaultFeeds} configuration={configuration}>
            <NavigationAdminVisibleByReferenceProvider visibleByReference={visibleByGroupReferences}>
                <NavigationListFilterProvider>{children}</NavigationListFilterProvider>
            </NavigationAdminVisibleByReferenceProvider>
        </NavigationAdminConfigurationProvider>
    );
};
